const filtersInitialState = {
  name: { active: false, value: '' },
  type: { active: false, value: '' },
  practice: { active: false, value: '' },
  industry: { active: false, value: '' },
  attorney: { active: false, value: '' },
  clear_filter: { active: false, value: '' },
  query: { active: true, value: '' },
};

const filters = (state = filtersInitialState, action) => {
  let filterName = action.filterName;
  let updatedFilterList = state;
  switch (action.type) {
    case 'UPDATE_FILTER_ACTIVE':
      if (action.value !== '') {
        updatedFilterList[filterName].active = true;
      } else {
        updatedFilterList[filterName].active = false;
      }

      if (filterName === 'clear_filter') {
        Object.keys(updatedFilterList).forEach(key => {
          if (key !== 'clear_filter') {
            updatedFilterList[key].active = false;
            updatedFilterList[key].value = '';
          }
        });
      }

      if (action.query === true) {        
        updatedFilterList.query.active = true;
      }

      updatedFilterList[filterName].value = action.value;
      return {
        type: action.type,
        ...updatedFilterList,
      };

    case 'CLEAR_FILTERS':
      Object.keys(updatedFilterList).forEach(key => {
        if (key !== 'clear_filter') {
          updatedFilterList[key].active = false;
          updatedFilterList[key].value = '';
        }

        if (key === 'clear_filter') {
          //console.log()
          updatedFilterList[key].active = updatedFilterList[key].active === true ? false : true;
          updatedFilterList[key].value = '';
        }

      });
      return {
        type: action.type,
        ...updatedFilterList
      };

    default:
      return {
        ...filtersInitialState
      };
  }
};

export default filters;
